
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/headhunt-service",
      function () {
        return require("private-next-pages/headhunt-service/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/headhunt-service"])
      });
    }
  